import { useState } from "react";
import { useSiteContent } from "@/lib/content";
import { usePageSeo } from "@/lib/seo";
import { CaseStudies, QuoteSection, SectionHead } from "@/components/site/Sections";

export default function Projects() {
  usePageSeo("/projects");
  const { gallery } = useSiteContent();
  const sectors = ["All", ...Array.from(new Set(gallery.map((g) => g.sector)))];
  const [sector, setSector] = useState("All");
  const items = gallery.filter((g) => sector === "All" || g.sector === sector);
  return (
    <>
      <section className="mx-auto max-w-7xl px-5 py-16 md:px-8 lg:py-24" data-testid="projects-page">
        <p className="eyebrow mb-3">Project gallery</p>
        <h1 className="text-4xl font-extrabold uppercase leading-none text-white sm:text-5xl lg:text-6xl">Floors that work for a living.</h1>
        <div className="mt-10 flex flex-wrap gap-2">
          {sectors.map((s) => (
            <button
              key={s}
              onClick={() => setSector(s)}
              data-testid={`gallery-filter-${s.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className={`border px-4 py-2 font-mono text-xs uppercase transition-colors ${sector === s ? "border-brand-500 bg-brand-500 text-black" : "border-slate-700 text-slate-300 hover:border-brand-500"}`}
            >
              {s}
            </button>
          ))}
        </div>
        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((g) => (
            <figure key={g.src + g.title} className="group relative overflow-hidden border border-slate-800" data-testid="gallery-item">
              <img src={g.src} alt={g.title} loading="lazy" className="aspect-[4/3] w-full object-cover transition-transform duration-700 group-hover:scale-105" />
              <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/90 to-transparent p-4">
                <span className="font-mono text-[11px] uppercase text-brand-500">{g.sector}{g.suburb ? ` · ${g.suburb}` : ""}</span>
                <div className="font-display text-xl font-bold uppercase text-white">{g.title}</div>
              </figcaption>
            </figure>
          ))}
        </div>
      </section>
      <section className="bg-[#161920]">
        <div className="mx-auto max-w-7xl px-5 py-20 md:px-8">
          <SectionHead eyebrow="Case studies" title="How we delivered." />
          <CaseStudies limit={12} />
        </div>
      </section>
      <QuoteSection />
    </>
  );
}
